// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MainNavigation-module__font-s-10___JGnE6 {
  font-size: 10px !important;
}

.MainNavigation-module__font-s-12___p5t0E {
  font-size: 12px !important;
}

.MainNavigation-module__font-s-13___NFoIL {
  font-size: 13px !important;
}

.MainNavigation-module__font-s-14___wIfrq {
  font-size: 14px !important;
}

.MainNavigation-module__font-s-15___WlGRF {
  font-size: 15px !important;
}

.MainNavigation-module__font-s-16___uM9J9 {
  font-size: 16px !important;
}

.MainNavigation-module__font-s-18___zjwI5 {
  font-size: 18px !important;
}

.MainNavigation-module__font-s-20___E4qAS {
  font-size: 20px !important;
}

.MainNavigation-module__font-s-22___ARiPx {
  font-size: 22px !important;
}

.MainNavigation-module__font-s-28___MxS4K {
  font-size: 28px !important;
}

.MainNavigation-module__font-w-400___Ir7yI {
  font-weight: 400 !important;
}

.MainNavigation-module__font-w-500___P1_wB {
  font-weight: 500 !important;
}

.MainNavigation-module__font-w-600___rCE8m {
  font-weight: 600 !important;
}

.MainNavigation-module__font-w-700___EDNGE {
  font-weight: 700 !important;
}

.MainNavigation-module__p-5___RsdDL {
  padding: 5px !important;
}

.MainNavigation-module__p-12___iij_R {
  padding: 12px !important;
}

.MainNavigation-module__p-16___irOSZ {
  padding: 16px !important;
}

.MainNavigation-module__p-30___iO8Ur {
  padding: 30px !important;
}

.MainNavigation-module__p-b-0___X5H6Q {
  padding-bottom: 0 !important;
}

.MainNavigation-module__p-b-5___lyJte {
  padding-bottom: 5px !important;
}

.MainNavigation-module__p-b-10___i1fdx {
  padding-bottom: 10px !important;
}

.MainNavigation-module__p-b-12___szTHC {
  padding-bottom: 12px !important;
}

.MainNavigation-module__p-b-16___eefAQ {
  padding-bottom: 16px !important;
}

.MainNavigation-module__p-b-18___qnMxK {
  padding-bottom: 18px !important;
}

.MainNavigation-module__p-b-20___jOMP5 {
  padding-bottom: 20px !important;
}

.MainNavigation-module__p-b-25___Cpt77 {
  padding-bottom: 25px !important;
}

.MainNavigation-module__p-b-30___Ve6F7 {
  padding-bottom: 30px !important;
}

.MainNavigation-module__p-b-50___Ej1wa {
  padding-bottom: 50px !important;
}

.MainNavigation-module__p-t-0___mgy2t {
  padding-top: 0 !important;
}

.MainNavigation-module__p-t-12___axPCx {
  padding-top: 12px !important;
}

.MainNavigation-module__p-t-16___DtFwX {
  padding-top: 16px !important;
}

.MainNavigation-module__p-t-18___xRen0 {
  padding-top: 18px !important;
}

.MainNavigation-module__p-t-20___Oi6yY {
  padding-top: 20px !important;
}

.MainNavigation-module__p-t-30___LhRG3 {
  padding-top: 30px !important;
}

.MainNavigation-module__p-t-40___rFFlV {
  padding-top: 40px !important;
}

.MainNavigation-module__p-t-50___Qj7eT {
  padding-top: 50px !important;
}

.MainNavigation-module__p-l-20___hvITb {
  padding-left: 20px !important;
}

.MainNavigation-module__p-l-30___ihgPw {
  padding-left: 30px !important;
}

.MainNavigation-module__p-l-40___SxrNe {
  padding-left: 40px !important;
}

.MainNavigation-module__p-r-16___YqPlF {
  padding-right: 16px !important;
}

.MainNavigation-module__p-r-20___pUG69 {
  padding-right: 20px !important;
}

.MainNavigation-module__p-r-30___wfvED {
  padding-right: 30px !important;
}

.MainNavigation-module__p-r-50___ukMfR {
  padding-right: 50px !important;
}

.MainNavigation-module__p-r-60___dX__m {
  padding-right: 60px !important;
}

.MainNavigation-module__m-b-1___LjgjR {
  margin-bottom: 1px !important;
}

.MainNavigation-module__m-b-2___yZ9mY {
  margin-bottom: 2px !important;
}

.MainNavigation-module__m-b-6___zhEKv {
  margin-bottom: 6px !important;
}

.MainNavigation-module__m-b-8___ioUTD {
  margin-bottom: 8px !important;
}

.MainNavigation-module__m-b-10___LCkNN {
  margin-bottom: 10px !important;
}

.MainNavigation-module__m-b-14___jYuae {
  margin-bottom: 14px !important;
}

.MainNavigation-module__m-b-16___W8tX4 {
  margin-bottom: 16px !important;
}

.MainNavigation-module__m-b-20___jq2Wk {
  margin-bottom: 20px !important;
}

.MainNavigation-module__m-b-22___j2cO_ {
  margin-bottom: 22px !important;
}

.MainNavigation-module__m-b-24___D_quR {
  margin-bottom: 24px !important;
}

.MainNavigation-module__m-b-30___foGop {
  margin-bottom: 30px !important;
}

.MainNavigation-module__m-b-32___QBW8E {
  margin-bottom: 32px !important;
}

.MainNavigation-module__m-b-40___zMj8i {
  margin-bottom: 40px !important;
}

.MainNavigation-module__m-t-2___SAzQc {
  margin-top: 2px !important;
}

.MainNavigation-module__m-t-3___jCBTg {
  margin-top: 3px !important;
}

.MainNavigation-module__m-t-4___K0ZKK {
  margin-top: 4px !important;
}

.MainNavigation-module__m-t-5____mdPl {
  margin-top: 5px !important;
}

.MainNavigation-module__m-t-8___C_J95 {
  margin-top: 8px !important;
}

.MainNavigation-module__m-t-10___CKCaJ {
  margin-top: 10px !important;
}

.MainNavigation-module__m-t-15___XvGIf {
  margin-top: 15px !important;
}

.MainNavigation-module__m-t-16___fP49b {
  margin-top: 16px !important;
}

.MainNavigation-module__m-t-20___cKh5t {
  margin-top: 20px !important;
}

.MainNavigation-module__m-t-22___imKek {
  margin-top: 22px !important;
}

.MainNavigation-module__m-t-30___n3K49 {
  margin-top: 30px !important;
}

.MainNavigation-module__m-t-32___NTyO8 {
  margin-top: 32px !important;
}

.MainNavigation-module__m-l-auto___ePz_Y {
  margin-left: auto !important;
}

.MainNavigation-module__m-l-4___WMiA4 {
  margin-left: 4px !important;
}

.MainNavigation-module__m-l-5___CiZBS {
  margin-left: 5px !important;
}

.MainNavigation-module__m-l-6___f5hxB {
  margin-left: 6px !important;
}

.MainNavigation-module__m-l-8___RPSWn {
  margin-left: 8px !important;
}

.MainNavigation-module__m-l-10___KNaQO {
  margin-left: 10px !important;
}

.MainNavigation-module__m-l-16___ecRsF {
  margin-left: 16px !important;
}

.MainNavigation-module__m-l-20____3BsF {
  margin-left: 20px !important;
}

.MainNavigation-module__m-l-24___hahVv {
  margin-left: 24px !important;
}

.MainNavigation-module__m-l-30___bocys {
  margin-left: 30px !important;
}

.MainNavigation-module__m-l-35___A_0ep {
  margin-left: 35px !important;
}

.MainNavigation-module__m-l-40___viozI {
  margin-left: 40px !important;
}

.MainNavigation-module__m-r-8___5_o7I {
  margin-right: 8px !important;
}

.MainNavigation-module__m-r-10___zhxkX {
  margin-right: 10px !important;
}

.MainNavigation-module__m-r-16___jiODo {
  margin-right: 16px !important;
}

.MainNavigation-module__m-r-20___dVM8K {
  margin-right: 20px !important;
}

.MainNavigation-module__m-r-24___kJWlS {
  margin-right: 24px !important;
}

.MainNavigation-module__m-r-30___GVIH7 {
  margin-right: 30px !important;
}

.MainNavigation-module__m-r-40___RboRn {
  margin-right: 40px !important;
}

.MainNavigation-module__border-r-3___dDK62 {
  border-radius: 3px !important;
}

.MainNavigation-module__border-r-4___qIB11 {
  border-radius: 4px !important;
}

.MainNavigation-module__border-r-6___oeCv9 {
  border-radius: 6px !important;
}

.MainNavigation-module__border-r-10___YrVMo {
  border-radius: 10px !important;
}

.MainNavigation-module__border-r-12____ygyr {
  border-radius: 12px !important;
}

.MainNavigation-module__border-r-16___nsLI3 {
  border-radius: 16px !important;
}

.MainNavigation-module__border-r-50___KHazt {
  border-radius: 50% !important;
}

.MainNavigation-module__primary-border___db_BS {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MainNavigation-module__primary-border-b___yNU8n {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MainNavigation-module__primary-border-t___ysRRX {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MainNavigation-module__primary-border-l___i0lT7 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MainNavigation-module__primary-border-r___tTyeo {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MainNavigation-module__secondary-border___AdeOV {
  border: 1px solid #637768;
}

.MainNavigation-module__secondary-border-b___VomYA {
  border-bottom: 1px solid #637768;
}

.MainNavigation-module__secondary-border-t___WGdAw {
  border-top: 1px solid #637768;
}

.MainNavigation-module__secondary-border-l___Rf886 {
  border-left: 1px solid #637768;
}

.MainNavigation-module__secondary-border-r___plboG {
  border-right: 1px solid #637768;
}

.MainNavigation-module__gap-0___HImVV {
  gap: 0 !important;
}

.MainNavigation-module__gap-2___tnPT9 {
  gap: 2px !important;
}

.MainNavigation-module__gap-4___f2W55 {
  gap: 4px !important;
}

.MainNavigation-module__gap-5___RpWJJ {
  gap: 5px !important;
}

.MainNavigation-module__gap-6___Nr9mv {
  gap: 6px !important;
}

.MainNavigation-module__gap-8___jFLEE {
  gap: 8px !important;
}

.MainNavigation-module__gap-10___s1N61 {
  gap: 10px !important;
}

.MainNavigation-module__gap-12___GBqI9 {
  gap: 12px !important;
}

.MainNavigation-module__gap-14___eQ7Xj {
  gap: 14px !important;
}

.MainNavigation-module__gap-16___Z_JMj {
  gap: 16px !important;
}

.MainNavigation-module__gap-18___g6S9d {
  gap: 18px !important;
}

.MainNavigation-module__gap-20___V0_d_ {
  gap: 20px !important;
}

.MainNavigation-module__gap-24___G7Zbw {
  gap: 24px !important;
}

.MainNavigation-module__gap-26___kbyhz {
  gap: 26px !important;
}

.MainNavigation-module__gap-30___kUwvr {
  gap: 30px !important;
}

.MainNavigation-module__gap-32___NQmAX {
  gap: 32px !important;
}

.MainNavigation-module__gap-40___FgbdZ {
  gap: 40px !important;
}

.MainNavigation-module__gap-50___uRf9S {
  gap: 50px !important;
}

.MainNavigation-module__flex-1___KL9fh {
  flex: 1;
}

.MainNavigation-module__flex-none___KN96y {
  flex: none !important;
}

.MainNavigation-module__flex-column___K8Mju {
  display: flex;
  flex-direction: column !important;
}

.MainNavigation-module__flex-row___tF0fM {
  display: flex;
  flex-direction: row !important;
}

.MainNavigation-module__vertically-centered___wPW05 {
  display: flex;
  align-items: center !important;
}

.MainNavigation-module__horizontally-centered___JgJci {
  display: flex;
  justify-content: center !important;
}

.MainNavigation-module__horizontally-end___qXQrl {
  display: flex;
  justify-content: end !important;
}

.MainNavigation-module__vertically-start___fRXsv {
  display: flex;
  align-items: start !important;
}

.MainNavigation-module__space-between___fQi68 {
  display: flex;
  justify-content: space-between !important;
}

.MainNavigation-module__flex-wrap___iWACT {
  flex-wrap: wrap !important;
}

.MainNavigation-module__height-100___WoJkA {
  height: 100%;
}

.MainNavigation-module__width-50___ol4Eb {
  width: 50% !important;
}

.MainNavigation-module__width-100___MbhRC {
  width: 100%;
}

.MainNavigation-module__cursor-pointer___B6zpO {
  cursor: pointer;
}

.MainNavigation-module__cursor-not-allowed___RoecX {
  cursor: not-allowed !important;
}

.MainNavigation-module__absolute-centered___bEbwq {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MainNavigation-module__absolute___hK63g {
  position: absolute;
}

.MainNavigation-module__relative___KRbrp {
  position: relative;
}

.MainNavigation-module__fixed___FhLR9 {
  position: fixed;
}

.MainNavigation-module__visible___tSqIT {
  opacity: 1;
}

.MainNavigation-module__invisible___mHljn {
  opacity: 0;
}

.MainNavigation-module__col-90___WRdFL {
  width: 90% !important;
}

.MainNavigation-module__col-auto___GzlLu {
  width: auto !important;
}

.MainNavigation-module__medical-tabs___IwjWR {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MainNavigation-module__medical-table-new___SAspR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MainNavigation-module__medical-table-new___SAspR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MainNavigation-module__medical-table-new___SAspR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MainNavigation-module__medical-table-new___SAspR::-webkit-scrollbar-track {
  display: none;
}
.MainNavigation-module__medical-table-new___SAspR.MainNavigation-module__no-pagination___TG5Mv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MainNavigation-module__medical-table-new___SAspR.MainNavigation-module__no-pagination___TG5Mv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MainNavigation-module__medical-table-new___SAspR.MainNavigation-module__no-pagination___TG5Mv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MainNavigation-module__medical-table-new___SAspR.MainNavigation-module__no-pagination___TG5Mv::-webkit-scrollbar-track {
  display: none;
}

.MainNavigation-module__medical-table-empty___Qtjri {
  padding: 14px 40px !important;
}

.MainNavigation-module__icon-btn___gJ3ZD {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MainNavigation-module__search-icon___Tk5BZ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MainNavigation-module__disable-select___qQT_2 {
  user-select: none;
}

.MainNavigation-module__break-word___LJAox {
  word-break: break-word;
}

.MainNavigation-module__popup-clear-btn___riuYi {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MainNavigation-module__scroll-m-b-20___tnmp_ {
  scroll-margin-bottom: 20px;
}

.MainNavigation-module__root___jSovl {
  height: var(--top-navigation);
  width: 100vw;
  display: flex;
  flex-direction: row;
  flex: 1;
  background-color: #fbf7f2;
  border-bottom: 1px solid #e6e7e8;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__leftContainer___sRiBE {
  flex: 1;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__leftContainer___sRiBE .MainNavigation-module__headerLogo___cCImZ {
  margin: 0 15px 0 30px;
  align-items: center;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__leftContainer___sRiBE .MainNavigation-module__headerLogo___cCImZ .MainNavigation-module__logoImage___il8HB {
  width: 29px;
  height: 24px;
  object-fit: contain;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__leftContainer___sRiBE .MainNavigation-module__text___K2VKw {
  font-size: 18px;
  line-height: 27px;
  font-weight: 600;
  color: #375844;
  margin-left: 5px;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__leftContainer___sRiBE .MainNavigation-module__mrn___SGxyt {
  cursor: pointer;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__leftContainer___sRiBE .MainNavigation-module__patientTabs___ZTv6M {
  flex: 1;
  padding: 0 10px;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__rightContainer___Dj3dX {
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 35px;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__rightContainer___Dj3dX .MainNavigation-module__autocomplete___SHtaM {
  background-color: white;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__rightContainer___Dj3dX .MainNavigation-module__icon___woTrH {
  width: 37px;
  height: 37px;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__rightContainer___Dj3dX .MainNavigation-module__accountMenuButton___e_T8A {
  display: flex;
  align-items: center;
  margin-left: 15px;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__rightContainer___Dj3dX .MainNavigation-module__accountButton___N6iW0 {
  cursor: pointer;
}
.MainNavigation-module__root___jSovl .MainNavigation-module__rightContainer___Dj3dX .MainNavigation-module__accountButton___N6iW0 .MainNavigation-module__client___oM5n7 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
  line-height: 27px;
  margin: 0 4px 0 18px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainNavigation/MainNavigation.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,yBAAA;EACA,gCAAA;AA8pBF;AA5pBE;EACE,OAAA;AA8pBJ;AA5pBI;EACE,qBAAA;EACA,mBAAA;AA8pBN;AA5pBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA8pBR;AA1pBI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AA4pBN;AAzpBI;EACE,eAAA;AA2pBN;AAxpBI;EACE,OAAA;EACA,eAAA;AA0pBN;AAtpBE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAwpBJ;AAtpBI;EACE,uBAAA;AAwpBN;AArpBI;EACE,WAAA;EACA,YAAA;AAupBN;AAppBI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAspBN;AAnpBI;EACE,eAAA;AAqpBN;AAnpBM;EC9DJ,gBAAA;EACA,mBAAA;EACA,uBAAA;ECoBA,+BApBO;EAqBP,gBAFmD;EF4C7C,cAAA;EACA,iBAAA;EACA,oBAAA;AAwpBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.root {\n  height: var(--top-navigation);\n  width: 100vw;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  background-color: get-color(orangeNew, light);\n  border-bottom: 1px solid get-color(gray, light);\n\n  .leftContainer {\n    flex: 1;\n\n    .headerLogo {\n      margin: 0 15px 0 30px;\n      align-items: center;\n\n      .logoImage {\n        width: 29px;\n        height: 24px;\n        object-fit: contain;\n      }\n    }\n\n    .text {\n      font-size: 18px;\n      line-height: 27px;\n      font-weight: 600;\n      color: get-color(greenNew, dark);\n      margin-left: 5px;\n    }\n\n    .mrn {\n      cursor: pointer;\n    }\n\n    .patientTabs {\n      flex: 1;\n      padding: 0 10px;\n    }\n  }\n\n  .rightContainer {\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-right: 35px;\n\n    .autocomplete {\n      background-color: white;\n    }\n\n    .icon {\n      width: 37px;\n      height: 37px;\n    }\n\n    .accountMenuButton {\n      display: flex;\n      align-items: center;\n      margin-left: 15px;\n    }\n\n    .accountButton {\n      cursor: pointer;\n\n      .client {\n        @include clipped-text;\n        @include get-font($roboto);\n        color: get-color(greenNew, dark);\n        line-height: 27px;\n        margin: 0 4px 0 18px;\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MainNavigation-module__font-s-10___JGnE6`,
	"fontS12": `MainNavigation-module__font-s-12___p5t0E`,
	"fontS13": `MainNavigation-module__font-s-13___NFoIL`,
	"fontS14": `MainNavigation-module__font-s-14___wIfrq`,
	"fontS15": `MainNavigation-module__font-s-15___WlGRF`,
	"fontS16": `MainNavigation-module__font-s-16___uM9J9`,
	"fontS18": `MainNavigation-module__font-s-18___zjwI5`,
	"fontS20": `MainNavigation-module__font-s-20___E4qAS`,
	"fontS22": `MainNavigation-module__font-s-22___ARiPx`,
	"fontS28": `MainNavigation-module__font-s-28___MxS4K`,
	"fontW400": `MainNavigation-module__font-w-400___Ir7yI`,
	"fontW500": `MainNavigation-module__font-w-500___P1_wB`,
	"fontW600": `MainNavigation-module__font-w-600___rCE8m`,
	"fontW700": `MainNavigation-module__font-w-700___EDNGE`,
	"p5": `MainNavigation-module__p-5___RsdDL`,
	"p12": `MainNavigation-module__p-12___iij_R`,
	"p16": `MainNavigation-module__p-16___irOSZ`,
	"p30": `MainNavigation-module__p-30___iO8Ur`,
	"pB0": `MainNavigation-module__p-b-0___X5H6Q`,
	"pB5": `MainNavigation-module__p-b-5___lyJte`,
	"pB10": `MainNavigation-module__p-b-10___i1fdx`,
	"pB12": `MainNavigation-module__p-b-12___szTHC`,
	"pB16": `MainNavigation-module__p-b-16___eefAQ`,
	"pB18": `MainNavigation-module__p-b-18___qnMxK`,
	"pB20": `MainNavigation-module__p-b-20___jOMP5`,
	"pB25": `MainNavigation-module__p-b-25___Cpt77`,
	"pB30": `MainNavigation-module__p-b-30___Ve6F7`,
	"pB50": `MainNavigation-module__p-b-50___Ej1wa`,
	"pT0": `MainNavigation-module__p-t-0___mgy2t`,
	"pT12": `MainNavigation-module__p-t-12___axPCx`,
	"pT16": `MainNavigation-module__p-t-16___DtFwX`,
	"pT18": `MainNavigation-module__p-t-18___xRen0`,
	"pT20": `MainNavigation-module__p-t-20___Oi6yY`,
	"pT30": `MainNavigation-module__p-t-30___LhRG3`,
	"pT40": `MainNavigation-module__p-t-40___rFFlV`,
	"pT50": `MainNavigation-module__p-t-50___Qj7eT`,
	"pL20": `MainNavigation-module__p-l-20___hvITb`,
	"pL30": `MainNavigation-module__p-l-30___ihgPw`,
	"pL40": `MainNavigation-module__p-l-40___SxrNe`,
	"pR16": `MainNavigation-module__p-r-16___YqPlF`,
	"pR20": `MainNavigation-module__p-r-20___pUG69`,
	"pR30": `MainNavigation-module__p-r-30___wfvED`,
	"pR50": `MainNavigation-module__p-r-50___ukMfR`,
	"pR60": `MainNavigation-module__p-r-60___dX__m`,
	"mB1": `MainNavigation-module__m-b-1___LjgjR`,
	"mB2": `MainNavigation-module__m-b-2___yZ9mY`,
	"mB6": `MainNavigation-module__m-b-6___zhEKv`,
	"mB8": `MainNavigation-module__m-b-8___ioUTD`,
	"mB10": `MainNavigation-module__m-b-10___LCkNN`,
	"mB14": `MainNavigation-module__m-b-14___jYuae`,
	"mB16": `MainNavigation-module__m-b-16___W8tX4`,
	"mB20": `MainNavigation-module__m-b-20___jq2Wk`,
	"mB22": `MainNavigation-module__m-b-22___j2cO_`,
	"mB24": `MainNavigation-module__m-b-24___D_quR`,
	"mB30": `MainNavigation-module__m-b-30___foGop`,
	"mB32": `MainNavigation-module__m-b-32___QBW8E`,
	"mB40": `MainNavigation-module__m-b-40___zMj8i`,
	"mT2": `MainNavigation-module__m-t-2___SAzQc`,
	"mT3": `MainNavigation-module__m-t-3___jCBTg`,
	"mT4": `MainNavigation-module__m-t-4___K0ZKK`,
	"mT5": `MainNavigation-module__m-t-5____mdPl`,
	"mT8": `MainNavigation-module__m-t-8___C_J95`,
	"mT10": `MainNavigation-module__m-t-10___CKCaJ`,
	"mT15": `MainNavigation-module__m-t-15___XvGIf`,
	"mT16": `MainNavigation-module__m-t-16___fP49b`,
	"mT20": `MainNavigation-module__m-t-20___cKh5t`,
	"mT22": `MainNavigation-module__m-t-22___imKek`,
	"mT30": `MainNavigation-module__m-t-30___n3K49`,
	"mT32": `MainNavigation-module__m-t-32___NTyO8`,
	"mLAuto": `MainNavigation-module__m-l-auto___ePz_Y`,
	"mL4": `MainNavigation-module__m-l-4___WMiA4`,
	"mL5": `MainNavigation-module__m-l-5___CiZBS`,
	"mL6": `MainNavigation-module__m-l-6___f5hxB`,
	"mL8": `MainNavigation-module__m-l-8___RPSWn`,
	"mL10": `MainNavigation-module__m-l-10___KNaQO`,
	"mL16": `MainNavigation-module__m-l-16___ecRsF`,
	"mL20": `MainNavigation-module__m-l-20____3BsF`,
	"mL24": `MainNavigation-module__m-l-24___hahVv`,
	"mL30": `MainNavigation-module__m-l-30___bocys`,
	"mL35": `MainNavigation-module__m-l-35___A_0ep`,
	"mL40": `MainNavigation-module__m-l-40___viozI`,
	"mR8": `MainNavigation-module__m-r-8___5_o7I`,
	"mR10": `MainNavigation-module__m-r-10___zhxkX`,
	"mR16": `MainNavigation-module__m-r-16___jiODo`,
	"mR20": `MainNavigation-module__m-r-20___dVM8K`,
	"mR24": `MainNavigation-module__m-r-24___kJWlS`,
	"mR30": `MainNavigation-module__m-r-30___GVIH7`,
	"mR40": `MainNavigation-module__m-r-40___RboRn`,
	"borderR3": `MainNavigation-module__border-r-3___dDK62`,
	"borderR4": `MainNavigation-module__border-r-4___qIB11`,
	"borderR6": `MainNavigation-module__border-r-6___oeCv9`,
	"borderR10": `MainNavigation-module__border-r-10___YrVMo`,
	"borderR12": `MainNavigation-module__border-r-12____ygyr`,
	"borderR16": `MainNavigation-module__border-r-16___nsLI3`,
	"borderR50": `MainNavigation-module__border-r-50___KHazt`,
	"primaryBorder": `MainNavigation-module__primary-border___db_BS`,
	"primaryBorderB": `MainNavigation-module__primary-border-b___yNU8n`,
	"primaryBorderT": `MainNavigation-module__primary-border-t___ysRRX`,
	"primaryBorderL": `MainNavigation-module__primary-border-l___i0lT7`,
	"primaryBorderR": `MainNavigation-module__primary-border-r___tTyeo`,
	"secondaryBorder": `MainNavigation-module__secondary-border___AdeOV`,
	"secondaryBorderB": `MainNavigation-module__secondary-border-b___VomYA`,
	"secondaryBorderT": `MainNavigation-module__secondary-border-t___WGdAw`,
	"secondaryBorderL": `MainNavigation-module__secondary-border-l___Rf886`,
	"secondaryBorderR": `MainNavigation-module__secondary-border-r___plboG`,
	"gap0": `MainNavigation-module__gap-0___HImVV`,
	"gap2": `MainNavigation-module__gap-2___tnPT9`,
	"gap4": `MainNavigation-module__gap-4___f2W55`,
	"gap5": `MainNavigation-module__gap-5___RpWJJ`,
	"gap6": `MainNavigation-module__gap-6___Nr9mv`,
	"gap8": `MainNavigation-module__gap-8___jFLEE`,
	"gap10": `MainNavigation-module__gap-10___s1N61`,
	"gap12": `MainNavigation-module__gap-12___GBqI9`,
	"gap14": `MainNavigation-module__gap-14___eQ7Xj`,
	"gap16": `MainNavigation-module__gap-16___Z_JMj`,
	"gap18": `MainNavigation-module__gap-18___g6S9d`,
	"gap20": `MainNavigation-module__gap-20___V0_d_`,
	"gap24": `MainNavigation-module__gap-24___G7Zbw`,
	"gap26": `MainNavigation-module__gap-26___kbyhz`,
	"gap30": `MainNavigation-module__gap-30___kUwvr`,
	"gap32": `MainNavigation-module__gap-32___NQmAX`,
	"gap40": `MainNavigation-module__gap-40___FgbdZ`,
	"gap50": `MainNavigation-module__gap-50___uRf9S`,
	"flex1": `MainNavigation-module__flex-1___KL9fh`,
	"flexNone": `MainNavigation-module__flex-none___KN96y`,
	"flexColumn": `MainNavigation-module__flex-column___K8Mju`,
	"flexRow": `MainNavigation-module__flex-row___tF0fM`,
	"verticallyCentered": `MainNavigation-module__vertically-centered___wPW05`,
	"horizontallyCentered": `MainNavigation-module__horizontally-centered___JgJci`,
	"horizontallyEnd": `MainNavigation-module__horizontally-end___qXQrl`,
	"verticallyStart": `MainNavigation-module__vertically-start___fRXsv`,
	"spaceBetween": `MainNavigation-module__space-between___fQi68`,
	"flexWrap": `MainNavigation-module__flex-wrap___iWACT`,
	"height100": `MainNavigation-module__height-100___WoJkA`,
	"width50": `MainNavigation-module__width-50___ol4Eb`,
	"width100": `MainNavigation-module__width-100___MbhRC`,
	"cursorPointer": `MainNavigation-module__cursor-pointer___B6zpO`,
	"cursorNotAllowed": `MainNavigation-module__cursor-not-allowed___RoecX`,
	"absoluteCentered": `MainNavigation-module__absolute-centered___bEbwq`,
	"absolute": `MainNavigation-module__absolute___hK63g`,
	"relative": `MainNavigation-module__relative___KRbrp`,
	"fixed": `MainNavigation-module__fixed___FhLR9`,
	"visible": `MainNavigation-module__visible___tSqIT`,
	"invisible": `MainNavigation-module__invisible___mHljn`,
	"col90": `MainNavigation-module__col-90___WRdFL`,
	"colAuto": `MainNavigation-module__col-auto___GzlLu`,
	"medicalTabs": `MainNavigation-module__medical-tabs___IwjWR`,
	"medicalTableNew": `MainNavigation-module__medical-table-new___SAspR`,
	"noPagination": `MainNavigation-module__no-pagination___TG5Mv`,
	"medicalTableEmpty": `MainNavigation-module__medical-table-empty___Qtjri`,
	"iconBtn": `MainNavigation-module__icon-btn___gJ3ZD`,
	"searchIcon": `MainNavigation-module__search-icon___Tk5BZ`,
	"disableSelect": `MainNavigation-module__disable-select___qQT_2`,
	"breakWord": `MainNavigation-module__break-word___LJAox`,
	"popupClearBtn": `MainNavigation-module__popup-clear-btn___riuYi`,
	"scrollMB20": `MainNavigation-module__scroll-m-b-20___tnmp_`,
	"root": `MainNavigation-module__root___jSovl`,
	"leftContainer": `MainNavigation-module__leftContainer___sRiBE`,
	"headerLogo": `MainNavigation-module__headerLogo___cCImZ`,
	"logoImage": `MainNavigation-module__logoImage___il8HB`,
	"text": `MainNavigation-module__text___K2VKw`,
	"mrn": `MainNavigation-module__mrn___SGxyt`,
	"patientTabs": `MainNavigation-module__patientTabs___ZTv6M`,
	"rightContainer": `MainNavigation-module__rightContainer___Dj3dX`,
	"autocomplete": `MainNavigation-module__autocomplete___SHtaM`,
	"icon": `MainNavigation-module__icon___woTrH`,
	"accountMenuButton": `MainNavigation-module__accountMenuButton___e_T8A`,
	"accountButton": `MainNavigation-module__accountButton___N6iW0`,
	"client": `MainNavigation-module__client___oM5n7`
};
module.exports = ___CSS_LOADER_EXPORT___;
